import React, { useState, useEffect, useRef } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { ContentArea } from "../../../components/commons";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import {
  calculatePreviousDate,
  formatDate,
  getCurrentFinancialYear,
} from "../../../utils/commonFunctions";
import "./index.scss";
import subMilliseconds from "date-fns/subMilliseconds";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
type AppProps = {
  data?: any;
  approvedData?: any;
  redirectTab?: any;
  reDirectRequestId?: any;
};

const Calander = ({ data, approvedData, redirectTab,reDirectRequestId }: AppProps) => {
  const [finalClientList, setFinalClientList] = useState<any>([]);
  const [clientName, setClientName] = useState<any>({
    value: null,
    label: "Select Client..",
  });
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setoffset] = useState<number>(0);
  const [mode, setMode] = useState("AllWeek");
  const [eventData, setEventData] = useState([]);
  const [currentEsstimate, setCurrentEsstimate] = useState<any>([]);
  const [resources, setResources] = useState<any>([]); //left calander

  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const calendarRef = useRef<any>(null);
  const [calenderHerderSum, setCalenderHerderSum] = useState<any>([]);
  const [finalEsstimate, setFinalEsstimate] = useState<any>([]);
  const [calenderDate, setCalenderDate] = useState("");
  function findSmallestDate(data: any[]): string | null {
    if (data.length === 0) {
      return null; // Return null if the array is empty
    }

    let smallestDate = data[0].date;
    for (const item of data) {
      if (item?.date < smallestDate) {
        smallestDate = item?.date;
      }
    }
    return smallestDate?.split("T")[0];
  }

  useEffect(() => {
    if (data?.estimate_data) {
      const smallestDate = findSmallestDate(data?.estimate_data);

      if (smallestDate) {
        setCalenderDate(() => smallestDate?.split("T")[0]);
      }
    }
  }, [data]);
  ///single data
  useEffect(() => {
    setResources([])
    if (data?._id) {
      const obj = [{
        name:
          (data?.job?.job_id !== undefined ? `${data?.job?.job_id}_` : "") +
          (data?.job?.job_type !== undefined
            ? `${data?.job?.job_type}_`
            : `${data?.future_job?.job_type}_`) +
          formatDate(
            data?.job?.period_ended !== undefined
              ? data?.job?.period_ended
              : data.future_job?.period_ended
          ),
        id: 1,
        hours: data?.total_hours,
        clientName: `${data?.client_name} (${data?.client_code})`,
      },
      {
        name: ``,
        id: 2,
        hours: "",
      }]
      if(data?.total_hours){
      setResources([...obj])
    }
  }
}, [data]);

useEffect(() => {
  if (resources?.length > 0 && data?._id) {
    let sum = 0;
    for (let i of calenderHerderSum) {
      sum = sum + i?.name;
    }
    
    let sumTotal = {
      name: "Total Hours Allocated",
      id: 0,
      hours: sum,
    };
    setResources([...resources, sumTotal]);
  }
}, [approvedData, data, calenderHerderSum]);
////approved resources

useEffect(() => {
  if (approvedData?.length > 0) {
    let filterapprovedData = approvedData.filter(
      (el: any) => data?._id !== el?.req_id
    );

    let events = filterapprovedData?.map((ele: any, index: number) => {
      return {
        id: ele?.req_id,

        // name: `${ele?.period_ended + `_` + ele?.job_type+`_`+formatDate(data?.job?.period_ended)}`,
        name: `${(ele?.job_id ? ele?.job_id + `_` : "") +
          ele?.job_type +
          `_` +
          formatDate(ele?.period_ended)
          }`,
        hours: ele?.total_hours,
        clientName: `${ele?.client_name} (${ele?.client_code})`,
      };
    });
    if (currentEsstimate?.length) {
      setResources([
        ...resources,
        {
          name: `Employee Schedule`,
          id: 3,
          hours: "&",
        },
        ...events,
      ]);
    }
  }
}, [approvedData]);

//single calendar data

useEffect(() => {
  if (data?.estimate_data?.length > 0) {
    let events = data?.estimate_data?.map((el: any) => {
      return {
        // resourceId: el?.request_id,
        resourceId: 1,
        // campaignId: el?.request_id,
        campaignId: 1,
        name: el?.hours,
        start: new Date(el?.date),
        end: new Date(el?.date),
        allDay: true,
      };
    });

    setCurrentEsstimate([...events]);
  }
}, [data]);

// approved all data

useEffect(() => {
  if (approvedData?.length > 0) {
    let filterapprovedData = approvedData.filter(
      (el: any) => data?._id !== el?.req_id
    );
    let events = filterapprovedData
      ?.map((ele: any, index: number) => {
        return ele?.estimations?.map((el: any, i: number) => {
          return {
            resourceId: ele?.req_id,
            campaignId: ele?.req_id,
            name: el?.hours,
            start: new Date(el?.date),
            end: new Date(el?.date),
            allDay: true,
          };
        });
      })
      .flat();
    if (currentEsstimate?.length) {
      setCurrentEsstimate([...currentEsstimate, ...events]);
    }
  }
}, [approvedData]);

useEffect(() => {
  let arr: any = [];
  if (currentEsstimate?.length) {
    currentEsstimate?.forEach((el: any) => {
      let date = new Date(el?.start);
      let JsonDate = JSON.stringify(date);
      let final = JsonDate.slice(1, 11);
      arr.push({ date: final, hours: el?.name });
    });

    arr?.sort((a: any, b: any) => {
      if (a?.date !== b?.date) {
        return a?.date.localeCompare(b?.date);
      }
      return a?.hours - b?.hours;
    });
    ///sum of header sum
    const dateHoursMap: any = {};
    arr?.forEach((entry: any) => {
      const date = entry?.date;
      const hours = entry?.hours;
      if (date in dateHoursMap) {
        dateHoursMap[date] += hours;
      } else {
        dateHoursMap[date] = hours;
      }
    });

    const result = Object.entries(dateHoursMap).map(([date, hours]) => ({
      resourceId: 0,
      campaignId: 0,
      name: hours,
      start: new Date(date),
      end: new Date(date),
      allDay: true,
    }));

    setCalenderHerderSum(result);

    setFinalEsstimate([...result, ...currentEsstimate]);
  }
}, [currentEsstimate]);

let currentFinancial = getCurrentFinancialYear();

const computeDurations = (mode: any) => {
  switch (mode) {
    case "AllWeek":
      let finalResult: any = {
        slotDuration: { days: 1 },
        slotLabelFormat: [{ month: "long" }, { day: "2-digit" }],
        duration: { days: 366 },
      };
      return finalResult;

    default:
      return {};
  }
};

const CampaignResource = ({ resource }: any) => {
  const { name, from, to, type, hours, clientName } = resource.extendedProps;
  let finalName = name?.slice(0, 18) + "....";
  let finalClientName = clientName?.slice(0, 20) + "....";
  return (
    <>
      <td
        className="job-id"
        style={{
          color: "#262a44",
          fontSize: "14px",
          fontWeight: "500",
          background:
            name == "Employee Schedule" || name == "Total Hours Allocated"
              ? "rgba(191, 203, 225, 0.6)"
              : "white",
          width: "300px",
          wordWrap: "break-word",
        }}
      >
        {name === "Total Hours Allocated" ? (
          <span style={{ width: "100%" }} className="ml-2">
            {name}
          </span>
        ) : name?.length < 18 ? (
          <span className="ml-2" style={{ width: "100%" }}>
            {name}
            <br></br>
            <span style={{ fontSize: "12px", color: "#6e7491" }}>
              {clientName?.length > 20 ? finalClientName : clientName}
            </span>
          </span>
        ) : (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 250 }}
            overlay={<Tooltip id="button-view-open-item">

              <div className='d-flex flex-column'>
                <span>Job Type & ID : {name}</span>
                <span>Client Name : {clientName}</span>
              </div>
            </Tooltip>}
          >
            <span style={{ width: "100%" }} className="ml-2">
              {finalName}
              <br></br>
              <span style={{ fontSize: "12px", color: "#6e7491" }}>
                {clientName?.length > 20 ? finalClientName : clientName}
              </span>
            </span>
          </OverlayTrigger>
        )}
      </td>
      {name || name === "" ? (
        <td
          className="job-id"
          style={{
            color: hours === "&" ? "transparent" : "#262a44",
            fontSize: "14px",
            fontWeight: "500",
            background:
              name === "Employee Schedule" || name === "Total Hours Allocated"
                ? "rgba(191, 203, 225, 0.6)"
                : "white",
          }}
        >
          {hours}
        </td>
      ) : (
        ""
      )}
    </>
  );
};

const resourceAreaHeaderContent = (arg: any) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "65% 35%",
        justifyContent: "space-between",
        width: "100%",
        marginTop: "21px",
      }}
    >
      <div style={{ textAlign: "initial" }} className="ml-2">
        JOB TYPE & ID
      </div>
      <div className="mr-1">TOTAL HOURS</div>
    </div>
  );
};

const { duration, slotDuration, slotLabelFormat } = computeDurations(mode);

const handleEventContent = (eventInfo: any) => {
  if (
    selectedEvent &&
    selectedEvent?._def?.extendedProps?.campaignId ===
    eventInfo?.event?._def?.extendedProps?.campaignId
  ) {
    // let x=
    return <div></div>;
  } else if (eventInfo?.event?._def?.extendedProps?.name != 0) {
    let checkId = eventInfo?.event?._def?.extendedProps?.campaignId;
    let checkName = eventInfo?.event?._def?.extendedProps?.name;
    return (
      <>
        <div
          style={{
            // background:
            //   eventInfo?.event?._def?.extendedProps?.name < 12
            //     ? "#e7f0d4"
            //     : "#faedd8",
            height: "61.5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "15px",
            fontWeight: 500,
            width: "97%",
            margin: "auto",
            // color:
            //   eventInfo?.event?._def?.extendedProps?.name < 12
            //     ? "#5a7d0e"
            //     : "#ac6602",
          }}
        >
          <span
            style={{
              width: checkId != 0 ? "100%" : checkId === 0 ? "50%" : "100%",
              height: checkId === 0 && checkName > 12 ? "30px" : "61.5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                checkId === 0 && checkName >= 12
                  ? ""
                  : checkId === 0 && checkName <= 12
                    ? ""
                    : checkName < 12
                      ? "#e7f0d4"
                      : "#faedd8",

              color:
                checkId === 0 && checkName >= 12
                  ? ""
                  : checkId === 0 && checkName <= 12
                    ? ""
                    : checkName >= 12
                      ? "#ac6602"
                      : "#5a7d0e",
            }}
          >
            {" "}
            {checkName}
          </span>
        </div>
      </>
    );
  } else {
    return <div></div>;
  }
};

const handleEventResize = (info: any) => {
  const target = info.jsEvent.target;
  if (
    target.classList.contains("fc-resource-timeline-divider") ||
    target.classList.contains("fc-cell-shaded")
  ) {
    info.revert(); // Revert the resize
  }
};

return (
  <>
    <div className="manager">
      {calenderDate && (
        <FullCalendar
          ref={calendarRef}
          plugins={[resourceTimelinePlugin, dayGridPlugin]}
          initialView={"resourceTimeline"}
          initialDate={calenderDate}
          // resourcesInitiallyExpanded={false}
          // eventDurationEditable={false}
          resourceAreaWidth="30%"
          eventResize={handleEventResize} // Handle event resize
          resourceOrder="from"
          headerToolbar={{
            left: "",
            center: "title",
            right: "",
          }}
          height={"90vh"}
          // aspectRatio={"auto"}
          resourceAreaHeaderContent={resourceAreaHeaderContent}
          // eventResizable={false}
          slotDuration={slotDuration}
          slotLabelFormat={slotLabelFormat}
          duration={duration}
          resourceLabelContent={CampaignResource}
          resources={resources}
          events={finalEsstimate} //box events
          slotMinWidth={60}
          views={{
            resourceTimelineDay: {
              slowMinWidth: 50,
            },
          }}
          eventClick={(arg: any) => arg.jsEvent.preventDefault()} // Prevent default eventClick behavior
          eventContent={handleEventContent}
        />
      )}
    </div>
  </>
);
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Calander);
